import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store.ts';
import { getVendorsByService } from '../../slices/AssignmentSlice.ts';
import CustomTable from '../common/Table.tsx';

interface IVendorRes {
  s_no: number;
  id: number;
  vendor_name: string;
  care_category: number;
  service_name: string;
  date: string;
  assign: boolean;
}

interface AssignVendorProps {
  serviceId: number;
  isOpen: boolean;
  onVendorSelect: (vendor: IVendorRes) => void;
}

const AssignVendorPopup: React.FC<AssignVendorProps> = ({ 
  serviceId,
  isOpen,
  onVendorSelect
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { availableVendors, loading } = useSelector((state: RootState) => state.assignmentSlice);
  const [selectedVendor, setSelectedVendor] = useState<IVendorRes | null>(null);

  // Fetch vendors when the popup is opened
  React.useEffect(() => {
    if (isOpen && serviceId) {
      dispatch(getVendorsByService(serviceId));
    }
  }, [dispatch, serviceId, isOpen]);

  const handleVendorSelect = (vendor: IVendorRes) => {
    setSelectedVendor(vendor);
    onVendorSelect(vendor);
  };

  const columns = [
    {
      title: 'S.No',
      dataIndex: 's_no',
      key: 's_no',
      render: (s_no: number) => <span className="text-[#0A0A0A] font-medium text-sm">{s_no}</span>
    },
    {
      title: 'Vendor Name',
      dataIndex: 'vendor_name',
      key: 'vendor_name',
      render: (name: string) => <span className="text-[#0A0A0A] font-medium text-sm">{name}</span>
    },
    {
      title: 'Care Category',
      dataIndex: 'service_name',
      key: 'service_name',
      render: (service: string) => <span className="text-[#0A0A0A] font-medium text-sm">{service}</span>
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date: string) => <span className="text-[#0A0A0A] font-medium text-sm">{new Date(date).toLocaleDateString()}</span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (_: any, record: IVendorRes) => (
        <button
          onClick={() => handleVendorSelect(record)}
          className={`px-4 py-2 rounded-md text-sm font-medium ${
            selectedVendor?.id === record.id
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {selectedVendor?.id === record.id ? 'Selected' : 'Assign'}
        </button>
      )
    }
  ];

  if (!isOpen) return null;

  return (
    <div className="p-4">
      <div className="flex flex-col h-[85vh]">
        <div className="flex-1">
          <CustomTable
            columns={columns}
            dataSource={availableVendors}
            loading={loading}
            rowKey="id"
            className="vendor-selection-table"
          />
        </div>
      </div>
    </div>
  );
};

export default AssignVendorPopup;
